import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import SubscriptionCancellationRepository from "~/repository/Subscription/SubscriptionCancellationRepository";

class SubscriptionCancellationStore extends NestStore {
  /**
   * @property {number|null}
   */
  subscriptionId = null;

  /**
   * @property {SubscriptionCancellationRepository|null}
   */
  subscriptionCancellationRepository = null;

  constructor() {
    super();

    this.subscriptionCancellationRepository = new SubscriptionCancellationRepository();
  }

  @action
  update() {
    this.isSaving = true;

    return this.subscriptionCancellationRepository.update(this.subscriptionId).finally(() => {
      this.isSaving = false;
    });
  }
}

export default SubscriptionCancellationStore;
